export const MODULE_ID = 'mobileReports';
export const SEC_PER_WEEK = 7 * 24 * 60 * 60;
export const KPI_TYPES = {
    INJECTIONS: 'injections',
    VERY_HIGH: 'veryHigh',
    VERY_LOW: 'veryLow',
    STANDARD_DEVIATION: 'standardDeviation',
    PERSENT_OF_READING_IN_RANGE: 'persentOfReadingsInRange',
    AVERAGE_PRE_MEAL: 'averagePreMeal',
    AVERAGE__STRICT_POST_MEAL: 'averageStrictPostMeal',
    AVERAGE_OVERALL: 'averageOverall'
};
export const GLUCOSE_CONCENTRATION_LEVELS_BOTTOM_VALUES = {
    MG_DL: {
        maxValue: 350,
        veryHigh: 250,
        high: 180,
        target: 70,
        low: 54,
        veryLow: 0
    },
    MMOL_L: {
        maxValue: 20,
        veryHigh: 13.9,
        high: 10,
        target: 3.9,
        low: 3,
        veryLow: 0
    }
};
export const GLUCOSE_CONCENTRATION_LEVELS = {
    MG_DL: [
        GLUCOSE_CONCENTRATION_LEVELS_BOTTOM_VALUES.MG_DL.veryHigh,
        GLUCOSE_CONCENTRATION_LEVELS_BOTTOM_VALUES.MG_DL.high,
        GLUCOSE_CONCENTRATION_LEVELS_BOTTOM_VALUES.MG_DL.target,
        GLUCOSE_CONCENTRATION_LEVELS_BOTTOM_VALUES.MG_DL.low,
        GLUCOSE_CONCENTRATION_LEVELS_BOTTOM_VALUES.MG_DL.veryLow
    ],
    MMOL_L: [
        GLUCOSE_CONCENTRATION_LEVELS_BOTTOM_VALUES.MMOL_L.veryHigh,
        GLUCOSE_CONCENTRATION_LEVELS_BOTTOM_VALUES.MMOL_L.high,
        GLUCOSE_CONCENTRATION_LEVELS_BOTTOM_VALUES.MMOL_L.target,
        GLUCOSE_CONCENTRATION_LEVELS_BOTTOM_VALUES.MMOL_L.low,
        GLUCOSE_CONCENTRATION_LEVELS_BOTTOM_VALUES.MMOL_L.veryLow
    ]
};
export const BEFORE_MEAL_TARGET = {
    MG_DL: {
        max: 130,
        min: 70
    },
    MMOL_L: {
        max: 7.2,
        min: 3.9
    }
};
